<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div style="min-width: 200px">
        <v-tabs v-model="tab" grow class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.unPain">Unpaid</v-tab>
          <v-tab class="c-tab" v-if="permitObj.paid">Paid</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item v-if="permitObj.unPain">
          <unpaid-table></unpaid-table>
        </v-tab-item>
        <v-tab-item v-if="permitObj.paid">
          <paid-table></paid-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import PaidTable from "../../../components/StudentPanel/accounts/PaidTable.vue";
import UnpaidTable from "../../../components/StudentPanel/accounts/UnpaidTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "Accounts",
  components: {
    PaidTable,
    UnpaidTable,
    BreadCrumbs
  },
  data() {
    return {
      tab: null,
      permitObj : {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name
          }
        }
      ]
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "StudentAccounts";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    this.getPermittedArray();
  },
};
</script>

<style lang="scss" scoped>
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>